import { useApplicationContext } from '../../../../common/containers/ApplicationContext';

export function useShowMobileAppBanner(): boolean {
  const { config } = useApplicationContext();

  const mobileAppBannerEnabled = config.get<boolean>('dailyrent.MobileAppBanner.Enabled') || false;

  return mobileAppBannerEnabled;
}
